


const urlBase = 'https://api.enarm.bluedotmx.com/api/'
const urlTestImage = "https://dev.api.preparacionipn.mx/api/images/"

// ***************************************
// ---------------ENDPOINTS---------------
// ***************************************

const urlEmployee = urlBase + 'employee';
const urlSpecialities = urlBase + 'specialities';
const subSpecialities = urlBase + 'subspecialities';
const urlClinicalCases = urlBase + 'clinicalCases';
const uploadImg = urlBase + 'images'
const urlLogin = urlBase + 'login'



export {
  urlLogin,
  urlEmployee,
  urlSpecialities,
  subSpecialities,
  urlClinicalCases,
  uploadImg,
  //test
  urlTestImage
}
